import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchCampaignActivities } from "./campaignActivities.actions";
import { initialState } from "./campaignActivities.initial-state";
import { Activity } from "./campaignActivities.types";

const campaignActivitiesSlice = createSlice({
  name: "campaignActivities",
  initialState,
  reducers: {
    setCampaignActivities: (state, action: PayloadAction<Activity[]>) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCampaignActivities.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCampaignActivities.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(fetchCampaignActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch campaign activities";
      })
  },
});

export const { setCampaignActivities } = campaignActivitiesSlice.actions;
const campaignActivitiesReducer = campaignActivitiesSlice.reducer;
export default campaignActivitiesReducer;
